import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Avatar, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import styles from './HeaderMenu.module.css';

export default function HeaderMenu({ user }) {
    const infoTitle = (
        <div className={styles.infoTitle}>
            <span>Имя пользователя: </span>
            <span>{user && user.username}</span>
        </div>
    );

    return (
        <div className={styles.header}>
            <div className={styles.logoContainer}>
                <Link to='/'>
                    <div className={styles.imgContainer}>
                        <img className={styles.logo} src='/images/logo.png' alt='logo' />
                    </div>
                </Link>
                <div className={styles.projectName}>
                    <span>YF-Admin</span>
                </div>
            </div>
            <div className={styles.userInfoContainer}>
                <Tooltip title={infoTitle} placement='left'>
                    <div className={styles.info}>
                        <InfoCircleOutlined />
                    </div>
                </Tooltip>
                <div className={styles.avatar}>
                    <Avatar size={50} src='/images/avatar.svg' />
                </div>

                {/* <Tooltip title='Настройки' placement='left'>
                    <DropdownMenu isAdmin={user?.isAdmin}/>
                </Tooltip> */}
            </div>
        </div>
    );
}
